import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { BandwidthResult } from '../../../models/app/bandwidth-result';
import { PingResult } from '../../../models/app/ping-result';
import { DecimalPipe } from '@angular/common';
import { ToMbpsPipe } from '../../../shared/pipes/to-mbps.pipe';

@Component({
  selector: 'app-bandwidth-info-test',
  imports: [DecimalPipe, ToMbpsPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './bandwidth-info-test.component.html',
})
export class BandwidthInfoTestComponent {
  upload = input.required<BandwidthResult>();
  download = input.required<BandwidthResult>();
  ping = input.required<PingResult>();

  mos = computed(() => {
    const pingMos = this.ping()?.mos || 0;
    const downloadMos = this.download()?.mos || 0;
    const uploadMos = this.upload()?.mos || 0;

    console.log('MOS values:', pingMos, downloadMos, uploadMos);
    return Math.min(pingMos, downloadMos, uploadMos);
  });
}
